module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Categoria",
      "required": true,
      "error": _vm.getError('category', _vm.product.productId)
    }
  }, [_c('multiselect', {
    attrs: {
      "track-by": "name",
      "label": "name",
      "options": _vm.categories,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Selecione"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fdc3c14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/walmart/provide/Product.vue
// module id = 3154
// module chunks = 0